import * as React from "react";

import { ConnectorType, GetConnector } from "../../utilsConnectors";

const IntegrationNugget: React.FC<{
  int: ConnectorType;
}> = ({ int }) => {
  return GetConnector(int);
};

export default IntegrationNugget;
